import React, { useState, useEffect } from "react";
import SalesTabList from "../SalesTab/index";
import LocationList from "../Components/Location";
import PriceTypeList from "../Components/PriceType";
import ButtonColorList from "../Components/ButtonColor";
import API from "../Services/SalesTab";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DisplayOrder from "../Components/DisplayOrder";
import API1 from "../Services/Location";
const AddSalesTab = () => {
    const [tabName, setTabName] = useState("");
    const [buttonColor, setButtonColor] = useState("");
    const [displayOrder, setDisplayOrder] = useState("");
    const [locationId, setLocationId] = useState("");
    const [priceTypeId, setPriceTypeId] = useState("");
    const [errors, setErrors] = useState({});
    const [location, setLocation] = useState([]);
    const [selected, setSelected] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [getSelectAll, setGetSelectAll] = useState(false);

    useEffect(() => {
        bindLocation(1, 0);
    }, []);

    const bindLocation = async (is_active, limit) => {
        try {
            const payload = { is_active, limit };
            const response = await API1.getLocationList(payload);
            const locationData = response?.data?.data || [];
            setLocation(locationData);
            setSelected(new Array(locationData.length).fill(false));
        } catch (error) {
            console.error(error);
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            } else {
                toast.error("Failed to load Center");
            }
        }
    };

    const validateFields = () => {
        const errors = {};
        if (!tabName.trim()) errors.tabName = "Tab Name is required";
       // if (!buttonColor.trim()) errors.buttonColor = "Button Color is required";
        if (!priceTypeId.trim()) errors.priceTypeId = "Price Type is required";
        if (!selected.includes(true)) errors.locationId = "At least one Center must be selected";
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setErrors((prev) => {
                const updated = { ...prev };
                delete updated[fieldName];
                return updated;
            });
        }

        switch (fieldName) {
            case "tabName":
                setTabName(value);
                break;
            case "buttonColor":
                setButtonColor(value);
                break;
            case "displayOrder":
                setDisplayOrder(value);
                break;
            case "priceTypeId":
                setPriceTypeId(value);
                break;
            default:
                break;
        }
    };

    const handleCheckboxChange = (id) => {
        const updated = [...selected];
        const locationIndex = location.findIndex((loc) => loc.id === id);
        updated[locationIndex] = !updated[locationIndex];
        setSelected(updated);
        //console.log('dddd',updated)
        const allSelected = updated.every(Boolean);
        // console.log('dddddddd',allSelected);
        setSelectAll(allSelected);
    };

    const handleSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectAll(checked);

        const updatedSelected = new Array(location.length).fill(checked);
        setSelected(updatedSelected);
    };

    const handleOk = () => {
        const selectedLocationIds = location
            .map((loc, index) => (selected[index] ? loc.id : null))
            .filter((id) => id !== null);
        setGetSelectAll(selectedLocationIds);
    };

    const handelReset = () => {
        setSelected([]);
        setSelectAll(false);
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;

        const payload = {
            tab_name: tabName,
            button_color_id: parseInt(1),
            display_order: 0,
            location_id: getSelectAll,
            price_type_id: priceTypeId,
        };

        try {
            const data = await API.Create_Sales_Tab(payload);
            if (data.status === 200) {
                toast.success(data.data.message);
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error("Unexpected error");
            }
        } catch (error) {
            const msg = error?.response?.data?.message || "Unknown error occurred";
            toast.error(`Error: ${msg}`);
            if (error.response?.status === 403) window.location.replace("/Login");
        }
    };

    const handleCancel = () => window.location.reload();

    return (
        <div>
            <div className="col-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Add New</h4>
                        <div className="forms-sample">
                            <div className="row">
                                <div className="col-md-4">
                                    <label>Tab Name <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Tab Name"
                                        value={tabName}
                                        onChange={(e) => handleFieldChange(e, "tabName")}
                                    />
                                    {errors.tabName && <small className="text-danger">{errors.tabName}</small>}
                                </div>

                                <div className="col-md-4">
                                    <label>Center <span className="text-danger">*</span></label>

                                    <div className="dropdown">
                                        <button
                                            className="btn dropdown-toggle form-control text-start"
                                            type="button"
                                            aria-expanded="false"
                                            data-bs-toggle="modal"
                                            data-bs-target="#exampleModalCenter"
                                        >
                                            {(() => {
                                                const selectedLocations = location
                                                    .filter((_, index) => selected[index])
                                                    .map((loc) => loc.name);

                                                if (selectedLocations.length === 0) return "Select Centers";
                                                if (selectedLocations.length <= 1) return selectedLocations.join(",");
                                                return `${selectedLocations.slice(0, 1).join(", ")}...`;
                                            })()}
                                        </button>
                                        {errors.locationId && <small className="text-danger">{errors.locationId}</small>}
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <PriceTypeList
                                        selectedPriceType={priceTypeId}
                                        setSelectedPriceType={(type) => {
                                            setPriceTypeId(type);
                                            if (type.trim()) {
                                                setErrors((prev) => {
                                                    const updated = { ...prev };
                                                    delete updated.priceTypeId;
                                                    return updated;
                                                });
                                            }
                                        }}
                                    />
                                    {errors.priceTypeId && <small className="text-danger">{errors.priceTypeId}</small>}
                                </div>
                            </div>

                            <div className="mt-3">
                                <button className="btn btn-primary me-2" onClick={handleSubmit}>Submit</button>
                                <button className="btn btn-light" onClick={handleCancel}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SalesTabList />
            <ToastContainer />

            <div className="modal fade" id="exampleModalCenter" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Select Center</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={handelReset}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="container ms-3 me-2">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="form-check mb-3" style={{ display: "flex", alignItems: "center" }}>
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="select-all"
                                                checked={selectAll}
                                                onChange={handleSelectAll}
                                                style={{ boxShadow: "0 0 0 1px blue" }}
                                            />
                                            <label
                                                htmlFor="select-all"
                                                className="form-check-label"
                                                style={{ marginLeft: "8px", cursor: "pointer", userSelect: "none" }}
                                            >
                                                Select All
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    {location.map((loc, index) => (
                                        <div className="col-md-3" key={loc.id}>
                                            <div className="form-check" style={{ display: "flex", alignItems: "center" }}>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={`loc-${index}`}
                                                    checked={selected[index] || false}
                                                    onChange={() => handleCheckboxChange(loc.id)}
                                                    style={{ boxShadow: "0 0 0 1px blue" }}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={`loc-${index}`}
                                                    style={{ marginLeft: "8px", cursor: "pointer", userSelect: "none" }}
                                                >
                                                    {loc.name}
                                                </label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                                onClick={handelReset}
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleOk}
                            >
                                Ok
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddSalesTab;
